// extracted by mini-css-extract-plugin
export default {"commonWrapper":"ColorBySelector_commonWrapper__3V3uO","palletPreview":"ColorBySelector_palletPreview__2d-Zb","palletName":"ColorBySelector_palletName__d+6tJ"};